import { Box } from "@mui/material";
import { RichTreeView } from "@mui/x-tree-view/RichTreeView";
import { useContext, useEffect } from "react";
import { Context } from "../Context";
import { gettingCategories, gettingReportByCategoryId } from "utils/Reports";

const Step1 = () => {
	const {
		setItemTreeView,
		itemTreeView,
		setCategories,
		setReports,
		setLoadingCategories,
		setLoadingReports,
		selectedReports,
		setSelectedReports,
	} = useContext(Context);

	const getItems = async () => {
		let categories = await gettingCategories(
			setLoadingCategories,
			setCategories
		);

		await gettingReportByCategoryId(
			setLoadingReports,
			categories,
			setReports,
			setItemTreeView
		);
	};

	useEffect(() => {
		getItems();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<Box sx={{ width: 350, height: 350 }}>
				<RichTreeView
					items={itemTreeView}
					checkboxSelection
					multiSelect
					selectionPropagation={{
						parents: true,
						descendants: true,
					}}
					defaultExpandedItems={["8", "12"]}
					selectedItems={selectedReports}
					onSelectedItemsChange={(event, newSelected) => {
						console.log("newSelected", newSelected);
						setSelectedReports(newSelected);
					}}
				/>
			</Box>
		</>
	);
};

export { Step1 };
